import styled, { css } from 'styled-components';
const reviewGroupVariation = {
  miniature: css`
    justify-self: center;
    align-self: center;
  `,
  list: css`
    justify-self: left;
  `
};
export const ReviewGroup = styled.div`
  ${({
  displayMode
}) => displayMode && reviewGroupVariation[displayMode]};
  max-height: 20px;
`;